export default __webpack_public_path__ + "static/media/ola.593b127c.png";